// extracted by mini-css-extract-plugin
export default {"arrival":"NotificationArrival_arrival__fyIGz","notice":"NotificationArrival_notice__5F1W2","targetState":"NotificationArrival_targetState__4pRjZ"};